import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
import "../Print.css";
type CardDataProps = {
  cardData: Array<object>;
  creditCardTotal: any;
  source: string;
};

export const CardSummary: FunctionComponent<CardDataProps> = ({
  cardData,
  creditCardTotal,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>Card Summary</Typography>
            </Grid>
          </Grid>
          <Grid item lg={12}>
            <Table
              size="small"
              aria-label="a dense table"
              className={source === "print" ? classes.table : ""}
            >
              <TableHead className={classes.tableRow}>
                <TableRow>
                  <TableCell
                    align="center"
                    className={classes.headColor}
                    // style={{ width: "30%" }}
                  ></TableCell>

                  {/* <TableCell
                    align="right"
                    className={classes.headCell}
                    style={{ width: "25%" }}
                  >
                    Bills
                  </TableCell> */}
                  <TableCell
                    align="right"
                    className={classes.headCell}
                    style={{ width: "25%" }}
                  >
                    Bills
                  </TableCell>
                  <TableCell
                    align="right"
                    className={classes.headCell}
                    style={{ width: "25%" }}
                  >
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {cardData &&
                  cardData.map((c: any) => (
                    <TableRow>
                      <TableCell align="left" className={classes.headColor}>
                        {c.card_name}
                      </TableCell>
                      {/* <TableCell align="right" className={classes.headColor}>
                        {"0"}
                      </TableCell> */}
                      <TableCell align="right" className={classes.headColor}>
                        {c.CreditCardCount ? c.CreditCardCount : "0"}
                      </TableCell>
                      <TableCell align="right" className={classes.headColor}>
                        {c.CreditCardAmount ? c.CreditCardAmount : "0.00"}
                      </TableCell>
                    </TableRow>
                  ))}

                <TableRow>
                  <TableCell
                    align="left"
                    className={classes.headCell}
                    colSpan={2}
                  >
                    Total
                  </TableCell>

                  <TableCell align="right" className={classes.headCell}>
                    {creditCardTotal ? creditCardTotal : "0.00"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
